export const apiPricingPlans = [
    'Pricing2018PayPerEmail',
    'Pricing2018PayPerEmailPro',
    'Pricing2020PayPerEmail',
    'Pricing2020PayPerEmailPro',
];
